import { Injectable } from '@angular/core';
import { TenantInfo } from '../tenant/tenant-info';
import { AppConfig } from '../app.config';
import {
    CognitoUserPool,
    CognitoUserSession,
    ICognitoUserPoolData,
    CognitoRefreshToken,
} from 'amazon-cognito-identity-js';
import * as AWS from 'aws-sdk/global';
import * as CognitoIdentity from 'aws-sdk/clients/cognitoidentity';
// import * as CognitoSync from 'aws-sdk/clients/cognitosync';

require('amazon-cognito-js');


export const TOKEN_REVOKED = 'TOKEN_REVOKED';

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
}

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
    callback(): void;
    callbackWithParam(result: any): void;
}

class MemoryUserPoolDataStorage {
    data: any;
    constructor() {
        this.data = {};
    }
    key(n: number) {
        return Object.keys(this.data)[n];
    }
    getItem(key: string) { return this.data[key] }
    setItem(key: string, value: string) { this.data[key] = value }
    removeItem(key: string) { this.data[key] = undefined }
    clear() { this.data = {} }
}

@Injectable()
export class CognitoUtil {

    // public static _REGION = environment.region;

    // public static _IDENTITY_POOL_ID = environment.identityPoolId;
    // public static _USER_POOL_ID = environment.userPoolId;
    // public static _CLIENT_ID = environment.clientId;

    private _POOL_DATA;

    public cognitoCreds: AWS.CognitoIdentityCredentials;
    private tenantInfo: TenantInfo;


    constructor(private appConfig: AppConfig,
    ) {
        this.tenantInfo = appConfig.getTenantInfo();
        AWS.config.region = this.tenantInfo.region;
        this._POOL_DATA = {
            UserPoolId: this.tenantInfo.userPoolId,
            ClientId: this.tenantInfo.clientId,
            Storage: window.sessionStorage
            // Storage: new MemoryUserPoolDataStorage()
        } as ICognitoUserPoolData;
    }

    getUserPool() {
        return new CognitoUserPool(this._POOL_DATA);
    }

    getCurrentUser() {
        return this.getUserPool().getCurrentUser();
    }

    switchToMemoryStorage() {
        const memoryStorage = new MemoryUserPoolDataStorage();
        this._POOL_DATA.Storage = memoryStorage;
        const cognitoKeys: string[] = [];
        for (let i = 0; i < window.sessionStorage.length; i++) {
            const key = window.sessionStorage.key(i);
            if (key.startsWith('CognitoIdentityServiceProvider')) {
                memoryStorage.setItem(key, window.sessionStorage[key]);
                cognitoKeys.push(key);
            }
        }
        // Clear out  keys with cognito token info from session storage
        for (let i = 0; i < cognitoKeys.length; i++) {
            window.sessionStorage.removeItem(cognitoKeys[i]);
        }
    }

    // AWS Stores Credentials in many ways, and with TypeScript this means that
    // getting the base credentials we authenticated with from the AWS globals gets really murky,
    // having to get around both class extension and unions. Therefore, we're going to give
    // developers direct access to the raw, unadulterated CognitoIdentityCredentials
    // object at all times.
    setCognitoCreds(creds: AWS.CognitoIdentityCredentials) {
        this.cognitoCreds = creds;
    }

    getCognitoCreds() {
        return this.cognitoCreds;
    }

    // This method takes in a raw jwtToken and uses the global AWS config options to build a
    // CognitoIdentityCredentials object and store it for us. It also returns the object to the caller
    // to avoid unnecessary calls to setCognitoCreds.

    buildCognitoCreds(idTokenJwt: string) {
        const tenantInfo = this.tenantInfo;
        const url = 'cognito-idp.' + tenantInfo.region.toLowerCase() + '.amazonaws.com/' + tenantInfo.userPoolId;
        const logins: CognitoIdentity.LoginsMap = {};
        logins[url] = idTokenJwt;
        const params = {
            IdentityPoolId: tenantInfo.identityPoolId, /* required */
            Logins: logins
        };
        const creds = new AWS.CognitoIdentityCredentials(params);
        this.setCognitoCreds(creds);
        return creds;
    }


    getCognitoIdentity(): string {
        return this.cognitoCreds.identityId;
    }


    // We only use the Id Token (for the API call) and the Refresh token to refresh the Id token
    // getAccessToken(callback: Callback): void {
    //     if (callback == null) {
    //         throw new Error('CognitoUtil: callback in getAccessToken is null...returning');
    //     }
    //     if (this.getCurrentUser() != null) {
    //         this.getCurrentUser().getSession(function (err, session) {
    //             if (err) {
    //                 console.log('CognitoUtil: Can\'t set the credentials:' + err);
    //                 callback.callbackWithParam(null);
    //             } else {
    //                 if (session.isValid()) {
    //                     callback.callbackWithParam(session.getAccessToken().getJwtToken());
    //                 }
    //             }
    //         });
    //     } else {
    //         callback.callbackWithParam(null);
    //     }
    // }


    refresh(): void {
        this.getCurrentUser().getSession(function (err, session) {
            if (err) {
                console.log('CognitoUtil: Can\'t set the credentials:' + err);
            } else {
                if (session.isValid()) {
                    console.log('CognitoUtil: refreshed successfully');
                } else {
                    console.log('CognitoUtil: refreshed but session is still not valid');
                }
            }
        });
    }

    getUserAttributes(callback: Callback): void {
        if (callback == null) {
            throw new Error('CognitoUtil: callback in getUserAttributes is null...returning');
        }
        if (this.getCurrentUser() != null) {
            const currentUser = this.getCurrentUser();
            currentUser.getSession(function (err, session) {
                if (err) {
                    console.log('CognitoUtil: Can\'t get session to retrieve the user attributes:' + err);
                    callback.callbackWithParam(null);
                }
                // else {
                //     if (session.isValid()) {
                //         var attributeList = [];
                //         var attribute = {
                //             Name: 'custom:apiUrl',
                //             Value: 'http://123.456.789.000/api'
                //         }
                //         var cognitorAttribute = new CognitoUserAttribute(attribute);
                //         attributeList.push(attribute);
                //         currentUser.updateAttributes(attributeList, function (err, result) {
                //             if (err) {
                //                 alert(err);
                //                 return;
                //             }
                //             console.log('Update attribute result: ' + result);
                //         });
                //         currentUser.getUserAttributes((err, result) => {
                //             if (err) {
                //                 console.log("CognitoUtil: Can't get the user attributes:" + err);
                //                 callback.callbackWithParam(null);
                //             }
                //             else {
                //                 callback.callbackWithParam(result);
                //             }
                //         });
                //     }
                // }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    getSyncManagerDataSet(callback: Callback): void {
        const AWS2: any = AWS;
        const syncManager = new AWS2.CognitoSyncManager();
        const dataset = syncManager.openOrCreateDataset('UserPreferences', (err, data) => {
            if (err) {
                console.log('CognitoUtil: Can\'t get the Sync Manager DataSet:' + err);
                callback.callbackWithParam(null);
            } else {
                callback.callbackWithParam(data);
            }
        });


        // let client  = new CognitoSync();
        // client.describeDataset({
        //     DatasetName: "UserPreferences",
        //     IdentityId: this.getCognitoIdentity(),
        //     IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID
        // }, (err, data) => {
        //     if (err) {
        //         console.log("CognitoUtil: Can't get the Sync Manager DataSet:" + err);
        //         callback.callbackWithParam(null);
        //     }
        //     else {
        //         callback.callbackWithParam(data);
        //     }
        // });

    }



    async getSession(): Promise<CognitoUserSession> {
        return new Promise<CognitoUserSession>((resolve, reject) => {
            const cognitoUser = this.getCurrentUser();
            if (!cognitoUser) {
                reject(new Error('No Cognito User available'));
            }
            cognitoUser.getSession((err, session: CognitoUserSession) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(session);
                }
            });
        });
    }

    async getRefreshToken(): Promise<CognitoRefreshToken> {
        const session = await this.getSession();
        if (session.isValid()) {
            return session.getRefreshToken();
        }
    }

    async getTokenFromRefreshedSession(refreshToken: CognitoRefreshToken, type: 'ACCESS' | 'ID'): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const cognitoUser = this.getCurrentUser();
            cognitoUser.refreshSession(refreshToken, (err, session: CognitoUserSession) => {
                if (err) {
                    reject(err);
                } else {
                    if (type === 'ACCESS') {
                        resolve(session.getAccessToken().getJwtToken());
                    } else {
                        resolve(session.getIdToken().getJwtToken());
                    }
                }
            });
        });
    }

    async getJWTToken(type: 'ACCESS' | 'ID'): Promise<string> {
        if (this.appConfig.getUseJSONData()) {
            return 'TokenForJSONData';
        }
        const session = await this.getSession();
        let token;
        if (session.isValid()) {
            if (type === 'ACCESS') {
                token = session.getAccessToken().getJwtToken();
            } else {
                token = session.getIdToken().getJwtToken();
            }
        } else {
            try {
                const refreshToken = await this.getRefreshToken();
                if (!refreshToken) {
                    throw new Error('Could not retrieve refresh token');
                } else {
                    token = await this.getTokenFromRefreshedSession(refreshToken, type);
                }
            } catch (err) {
                console.log(`RefreshToken error: ${JSON.stringify(err)}`);
                if (err.message == 'Refresh Token has been revoked') {
                    return TOKEN_REVOKED;
                }
            }
        }
        let resetCredentials = false;
        const currentCreds = AWS.config.credentials;
        if (!currentCreds) {
            resetCredentials = true;
        } else {
            if (currentCreds instanceof AWS.Credentials) {
                const currentCredsCredintials = currentCreds as AWS.Credentials;
                if (currentCredsCredintials.needsRefresh()) {
                    resetCredentials = true;
                }
            }
        }
        if (resetCredentials) {
            // Set the AWS Creditials object logins to refresh the tokens
            // there too so that the web identify federated login requests work too
            const creds = this.buildCognitoCreds(token);
            AWS.config.credentials = creds;
        }
        return token;
    }

    async getAccessToken(): Promise<string> {
        return this.getJWTToken('ACCESS');
    }

    async getIdToken(): Promise<string> {
        return this.getJWTToken('ID');
    }

}
